import { createNamedContext } from '@trinity/chat-components';
import type { FocusedTagContextValue, TagsStateContextValue } from './interfaces';

export const TranscriptTagsContext = createNamedContext<TagsStateContextValue>(undefined, 'Transcript.Tagging.Tags.Context');
export const TranscriptFocusedTagContext = createNamedContext<FocusedTagContextValue>(undefined, 'Transcript.Tagging.FocusedTag.Context');